// extracted by mini-css-extract-plugin
export var container = "_35-1";
export var editor = "_35-2";
export var resizable = "_35-3";
export var wrapper = "_35-0";